module.exports = __webpack_public_path__ + "img/06_bastien-nvs.5399a838.jpg";